var _linearGradient, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstitutionDark(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    enableBackground: "new 0 0 512 512",
    height: 512,
    viewBox: "0 0 512 512",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "institution-dark",
    gradientUnits: "userSpaceOnUse",
    x1: 256,
    x2: 256,
    y1: 0.357,
    y2: 511.643
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#25f396"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#009cfb"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m0 471.643h512v40h-512zm512-345.467v66.467h-39.356c2.8 6.961 4.356 14.55 4.356 22.5v225.5h-442v-225.5c0-7.95 1.557-15.539 4.356-22.5h-39.356v-66.443l255.481-125.843zm-472 26.467h432v-1.534l-216.481-106.181-215.519 106.158zm236 62.5c0-11.304-9.196-20.5-20.5-20.5s-20.5 9.196-20.5 20.5v185.5h41zm-160 0c0-11.304-9.196-20.5-20.5-20.5s-20.5 9.196-20.5 20.5v185.5h41zm40 0v185.5h39v-185.5c0-7.95 1.557-15.539 4.356-22.5h-47.713c2.8 6.96 4.357 14.55 4.357 22.5zm281 0c0-11.304-9.196-20.5-20.5-20.5s-20.5 9.196-20.5 20.5v185.5h41zm-76.644-22.5h-48.713c2.8 6.961 4.356 14.55 4.356 22.5v185.5h40v-185.5c.001-7.95 1.558-15.54 4.357-22.5z",
    fill: "url(#institution-dark)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitutionDark);
export default __webpack_public_path__ + "static/media/InstitutionDark.a0aea6bb.svg";
export { ForwardRef as ReactComponent };